import { h } from "preact";

/**
 * The "Select the Type of Monogram" grid. Renders one button per available
 * monogram type as a radio group; the selected type is highlighted.
 */
export default function MonogramTypeSelector({
  types,
  selected,
  onSelect,
  labelFor,
}) {
  return (
    <div className="monogram-personalization__types" role="radiogroup">
      {types.map((type) => (
        <button
          key={type}
          type="button"
          role="radio"
          aria-checked={type === selected}
          className={`monogram-personalization__type ${
            type === selected ? "monogram-personalization__type--selected" : ""
          }`}
          onClick={() => onSelect(type)}
        >
          <span className="caption-1">{labelFor(type)}</span>
        </button>
      ))}
    </div>
  );
}
